import React from "react";
import { motion } from "framer-motion";
import MaskedLines from "@/components/MaskedLines";
import Reveal from "@/components/Reveal";
import { LinkedinLogo, EnvelopeSimple, ArrowUpRight } from "@phosphor-icons/react";

const LINKEDIN = "https://www.linkedin.com/in/marcodanieli73";
const EMAIL = "marco@mdconsultingsas.com";

export default function CTAFinale() {
  return (
    <section
      id="contatti"
      data-testid="section-contatti"
      className="relative py-32 md:py-40 lg:py-48 overflow-hidden"
    >
      {/* dramatic radial gold background */}
      <div aria-hidden className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full bg-gold/[0.08] blur-[160px]" />
      </div>

      <div
        aria-hidden
        className="absolute top-16 -left-4 md:left-10 font-display italic text-[14rem] md:text-[22rem] leading-none text-gold/[0.06] select-none pointer-events-none"
      >
        07
      </div>

      <div className="relative max-w-[1440px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="max-w-5xl">
          <Reveal>
            <div className="flex items-center gap-4 mb-10">
              <span className="w-10 h-px bg-gold" />
              <span
                className="text-[0.7rem] uppercase text-gold font-sans-crisp font-semibold"
                style={{ letterSpacing: "0.3em" }}
              >
                Capitolo 07 · Parliamone
              </span>
            </div>
          </Reveal>

          <div className="pr-4 sm:pr-0">
            <MaskedLines
              as="h2"
              testId="cta-headline"
              className="font-display font-medium tracking-tight sm:tracking-tighter leading-[1.05] sm:leading-[0.98] text-3xl sm:text-5xl md:text-7xl lg:text-8xl xl:text-9xl text-ink break-words"
              lines={[
                'Pronto a capire dove può',
                '<em class="italic-serif text-gold font-normal">arrivare la tua azienda?</em>',
              ]}
            />
          </div>

          <Reveal delay={0.3}>
            <p className="mt-12 text-lg md:text-xl text-ink/75 leading-relaxed max-w-2xl font-sans-crisp">
              Nessun impegno, nessun preventivo automatico.
              Una conversazione onesta con chi ha già affrontato il tuo problema.
            </p>
          </Reveal>

          <Reveal delay={0.4}>
            <div className="mt-14 md:mt-16 flex flex-col sm:flex-row gap-6 sm:items-start w-full">
              <a
                href={LINKEDIN}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="cta-linkedin"
                className="group relative inline-flex items-center justify-center gap-3 sm:gap-4 bg-gold text-navy-dark hover:bg-gold-light transition-colors duration-500 px-6 sm:px-8 py-4 sm:py-5 uppercase font-sans-crisp font-semibold text-[0.72rem] sm:text-[0.78rem] overflow-hidden w-full sm:w-auto whitespace-nowrap"
                style={{ letterSpacing: "0.16em" }}
              >
                <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/40 to-transparent" />
                <LinkedinLogo size={18} weight="fill" className="relative shrink-0" />
                <span className="relative">Scrivimi su LinkedIn</span>
                <ArrowUpRight size={16} weight="bold" className="relative shrink-0 transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </a>

              <a
                href={`mailto:${EMAIL}?subject=Contatto%20dal%20sito%20MD%20Consulting`}
                data-testid="cta-email"
                className="group inline-flex items-center justify-center gap-3 sm:gap-4 border border-gold/60 hover:border-gold text-gold hover:bg-gold/10 transition-colors duration-500 px-6 sm:px-8 py-4 sm:py-5 uppercase font-sans-crisp font-semibold text-[0.72rem] sm:text-[0.78rem] w-full sm:w-auto whitespace-nowrap"
                style={{ letterSpacing: "0.16em" }}
              >
                <EnvelopeSimple size={18} weight="light" className="shrink-0" />
                <span>Invia una mail</span>
                <ArrowUpRight size={16} weight="bold" className="shrink-0 transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </a>
            </div>
          </Reveal>

          {/* Small contact card */}
          <Reveal delay={0.5}>
            <motion.div
              className="mt-20 md:mt-24 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 lg:gap-14 pt-10 border-t border-gold/15"
            >
              <div>
                <p className="text-[0.7rem] uppercase text-gold font-sans-crisp font-semibold mb-3" style={{ letterSpacing: "0.24em" }}>
                  Email
                </p>
                <a
                  href={`mailto:${EMAIL}`}
                  className="font-display text-lg sm:text-xl md:text-2xl text-ink hover:text-gold transition-colors break-all"
                  data-testid="cta-email-address"
                >
                  {EMAIL}
                </a>
              </div>
              <div>
                <p className="text-[0.7rem] uppercase text-gold font-sans-crisp font-semibold mb-3" style={{ letterSpacing: "0.24em" }}>
                  LinkedIn
                </p>
                <a
                  href={LINKEDIN}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-display text-xl md:text-2xl text-ink hover:text-gold transition-colors"
                >
                  Marco Danieli
                </a>
              </div>
              <div>
                <p className="text-[0.7rem] uppercase text-gold font-sans-crisp font-semibold mb-3" style={{ letterSpacing: "0.24em" }}>
                  Sede
                </p>
                <p className="font-display text-xl md:text-2xl text-ink">
                  Treviso · Nord Est Italia
                </p>
              </div>
            </motion.div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
